document.addEventListener('DOMContentLoaded', function () {
  const popup = document.querySelector('[data-pf-tribe-popup]');

  if (!popup) return;

  const closeButtons = popup.querySelectorAll(
    '[data-pf-tribe-popup-close]'
  );

  const backdrop = popup.querySelector(
    '[data-pf-tribe-popup-backdrop]'
  );

  const sessionKey = 'pf_tribe_popup_seen';

  let popupShown = false;

  function openPopup() {
    if (popupShown) return;

    popupShown = true;

    popup.classList.add('is-active');

    popup.setAttribute('aria-hidden', 'false');

    document.documentElement.classList.add(
      'pf-tribe-popup-open'
    );

    sessionStorage.setItem(sessionKey, '1');
  }

  function closePopup() {
    popup.classList.remove('is-active');

    popup.setAttribute('aria-hidden', 'true');

    document.documentElement.classList.remove(
      'pf-tribe-popup-open'
    );
  }

  /* Close buttons */
  closeButtons.forEach(function (button) {
    button.addEventListener('click', closePopup);
  });

  /* Click backdrop */
  if (backdrop) {
    backdrop.addEventListener('click', closePopup);
  }

  /* ESC */
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closePopup();
    }
  });

  /*
   * Don't show again during this browser session.
   */
  if (sessionStorage.getItem(sessionKey)) {
    return;
  }

  /*
   * Slightly delayed first impression.
   */
  setTimeout(function () {
    openPopup();
  }, 12000);
});